import { vuexOidcCreateStoreModule } from 'vuex-oidc';
import oidcSettings from '../../config/oidc';
// eslint-disable-next-line import/no-cycle
import store from '../store';

const authStore = vuexOidcCreateStoreModule(
  oidcSettings,
  // Optionlaly define the store module as namespaced
  { namespaced: true, routeBase: process.env.BASE_URL },
  // Optional OIDC event listeners
  // remove these logs in production
  {
    userLoaded: () => {},
    userUnloaded: () => {},
    accessTokenExpiring: () => {
      // try to refresh the token
      store.dispatch('authStore/authenticateOidcSilent');
    },
    accessTokenExpired: () => {},
    silentRenewError: () => {},
    userSignedOut: () => {
      store.dispatch('authStore/silentLogOut');
    },
  }
);

// add silent logout action
authStore.actions['silentLogOut'] = ({ commit, getters }) => {
  // the token only last 15min which is 15*60*1000 = 900000 ms
  const tokenExp = 900000;
  const exp = getters.oidcIdTokenExp;
  // sometimes when user login, a user signed out event has been triggered,
  // this is used to prevent user logout instantly
  // so, if the function is been triggered within 10 seconds of user login event
  // ignore this event
  if (exp - new Date().getTime() > tokenExp - 10000) {
    return;
  }
  commit('unsetOidcAuth');
};

export default authStore;
